const types = Object.seal({
  game: 0,
  premium: 1,
  topPlay: 2,
  gameRecap: 3,
  other: 100,
});

export default types;
